import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to build a web3 game?",
    answer: `<p>While game development costs across the USA start from $10,000 USD – these are rough figures for independent milestones in game development. Actual Web3 game development costs depend on design complexity, the Blockchain technology you choose for integration, number of smart contracts and digital assets, backend capacity, testing and launching timelines.</p>`,
  },
  {
    question: "Which web3 game development services does TekRevol provide?",
    answer: `<p>At TekRevol, we have dedicated teams for Web3 game development and we specialize in UI/UX design, smart contract development and wallet integrations, digital assets design and development, tokenization, testing and code review, game development consultancy and game launches.</p>`,
  },
  {
    question: "What is Web3 game development?",
    answer: ` <p>A web3 game is built on Blockchain technology utilizing the conventional game development engines as well as programming languages like Solidity and Rust. These games often reward players with tokens, fractions of cryptocurrencies, cashbacks and discounts and NFTs.</p>`,
  },
  {
    question: "How long does it take to build and launch a web3 game?",
    answer: ` <p>The timelines for game development, testing and launch completely depend on the scope of the game. This scope includes design, storyline, character illustration and animations, and development teams. Here is a quick estimate of the time we commit to clients at TekRevol for Web3 game development:</p>
    <ul>
    <li>Simple Web3 game: 6 to 8 months</li>
     <li>Mid-Complexity, multi-featured game: 8 to 12 months</li>
      <li>Highly Complex Game: more than 12 months</li>
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Web3 Game Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
